import './Services.scss'

import TransparentFixed from '../../components/headers/TransparentFixed/TransparentFixed';
import BlackAndWhite from '../../components/footers/BlackAndWhite/BlackAndWhite';

import { useEffect, useState, useRef } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';

const Services = () => {

    const scrollToElement = useRef();

    const [isSuccess, setIsSuccess] = useState(false);

    let { id } = useParams();

    const [service, setService] = useState(() => {
        const saved = localStorage.getItem('service');
        const initialValue = saved;
        return initialValue || id || false;
    });

    const [firstName, setFirstName] = useState(() => {
        const saved = localStorage.getItem('firstName');
        const initialValue = saved;
        return initialValue || '';
    });

    const [phone, setPhone] = useState(() => {
        const saved = localStorage.getItem('phone');
        const initialValue = saved;
        return initialValue || '';
    });

    const [mail, setMail] = useState(() => {
        const saved = localStorage.getItem('mail');
        const initialValue = saved;
        return initialValue || '';
    });

    const [text, setText] = useState(() => {
        const saved = localStorage.getItem('text');
        const initialValue = saved;
        return initialValue || '';
    });

    const clearFormValues = () => {
        setService(false);
        setFirstName('');
        setPhone('');
        setMail('');
        setText('');

        localStorage.setItem('service', false);
        localStorage.removeItem('firstName');
        localStorage.removeItem('phone');
        localStorage.removeItem('mail');
        localStorage.removeItem('text');
    }

    const handleSubmit = event => {
        event.preventDefault();
        (isSuccess === false) && setIsSuccess(true);
        setTimeout(() => setIsSuccess(false), 5000);

        const formData = new FormData();
        formData.append('_captcha', false);
        formData.append('service', service);
        formData.append('firstName', firstName);
        formData.append('phone', phone);
        formData.append('mail', mail);
        formData.append('text', text);

        axios.post("https://formsubmit.co/3acebf40dc095bfbc357719cc67997df", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })

        clearFormValues();
    };

    const serviceHandler = (position) => {
        setService(position);
        scrollToElement.current.scrollIntoView({ behavior: "smooth", block: "center" });
        scrollToElement.current.focus();
    }

    useEffect(() => {
        localStorage.setItem('service', service);
        localStorage.setItem('firstName', firstName);
        localStorage.setItem('phone', phone);
        localStorage.setItem('mail', mail);
        localStorage.setItem('text', text);
    }, [service, firstName, phone, mail, text]);

    useEffect(() => {
        if (id) {
            setService(id);
            scrollToElement.current.scrollIntoView({ behavior: "smooth", block: "center" });
            scrollToElement.current.focus();
        }
    }, [id]);

    return (
        <>
            < TransparentFixed />
            <main className="main-container-services">
                {isSuccess && <div className="success-message"><p>Jūsų informacija buvo sėkmingai persiųsta, netrukus su Jumis susisieksime!</p></div>}
                <div className="container-services">
                    <div className="custom-field">
                        <h1>
                            <span>
                                Paslaugos
                            </span>
                        </h1>
                        <div className="services-wrapper">
                            <div className="center-container">
                                <div className="services service-first" onClick={() => serviceHandler('used-transport')}>
                                    <h4>Naudoti&nbsp;sunkvežimiai ir&nbsp;priekabos</h4>
                                </div>
                                <div className="services service-second" onClick={() => serviceHandler('transportation-cost')}>
                                    <h4>Transportavimo kainos</h4>
                                </div>
                                <div className="services service-third" onClick={() => serviceHandler('transport-maintenance')}>
                                    <h4>Sunkvežimių&nbsp;ir priekabų&nbsp;remontas</h4>
                                </div>
                                <div className="services service-fourth" onClick={() => serviceHandler('transport-rent')}>
                                    <h4>Transporto&nbsp;nuoma</h4>
                                </div>
                                <div className="services service-fifth" onClick={() => serviceHandler('logistics-service')}>
                                    <h4>Logistikos&nbsp;paslaugos</h4>
                                </div>
                                <div className="services service-sixth" onClick={() => serviceHandler('consulting')}>
                                    <h4>Konsultavimas</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <div className="background-container-services">
                <div className="container">
                    <div className="services-form-wrapper">
                        {isSuccess && <div className="success-message">Jūsų informacija buvo sėkmingai persiųsta, netrukus su Jumis susisieksime!</div>}
                        <form onSubmit={handleSubmit} className="services-form" action="https://formsubmit.co/andzejus.naimovicius@gmail.com" method="POST">
                            <input type="text" name="_honey" style={{ display: "none" }} />
                            <input type="hidden" name="_captcha" value="false" />

                            <div className="services-input-wrapper">
                                <select name="service" id="service" value={service} onChange={event => setService(event.target.value)}>
                                    <option value={false} hidden>Pasirinkite Jus dominantį klausimą</option>
                                    <option value="used-transport" id="used-transport">Naudoti sunkvežimiai ir priekabos</option>
                                    <option value="transportation-cost" id="transportation-cost">Transportavimo kainos</option>
                                    <option value="transport-maintenance" id="transport-maintenance">Sunkvežimių ir priekabų remontas</option>
                                    <option value="transport-rent" id="transport-rent">Transporto nuoma</option>
                                    <option value="logistics-service" id="logistics-service">Logistikos paslaugos</option>
                                    <option value="consulting" id="consulting">Konsultavimas</option>
                                </select>
                            </div>
                            <div className="name-input-wrapper">
                                <input ref={scrollToElement} value={firstName} onChange={event => setFirstName(event.target.value)} type="text" id="firstName" name="firstName" placeholder="Vardas" required />
                            </div>
                            <div className="phone-input-wrapper">
                                <input value={phone} onChange={event => setPhone(event.target.value)} type="tel" id="phone" name="phone" placeholder="Tel.numeris" required />
                            </div>
                            <div className="mail-service-wrapper">
                                <input value={mail} onChange={event => setMail(event.target.value)} type="email" id="mail" name="mail" placeholder="El.paštas" />
                            </div>
                            <div className="textarea-service-wrapper">
                                <textarea value={text} onChange={event => setText(event.target.value)} placeholder="Jūsų informacija:" rows="8" cols="50" id="text" name="text"></textarea>
                            </div>
                            <div className="buttons-service-wrapper">
                                <button onClick={clearFormValues} type="reset" className="secondary outline" id="reset-service">Išvalyti</button>
                                <button type="submit" className="primary outline">Pateikti</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <BlackAndWhite />
        </>
    );
}

export default Services;